"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ServiceRegistry = _interopRequireDefault(require("../util/ServiceRegistry"));
var _CallbackTypes = _interopRequireDefault(require("../constants/CallbackTypes"));
var _mobx = require("mobx");
var _ViewMode = _interopRequireWildcard(require("../constants/ViewMode"));
var _ConfigStoreConstants = require("../constants/ConfigStoreConstants");
var _AppUtil = require("../util/AppUtil");
var _KeyboardEventUtils = require("../util/KeyboardEventUtils");
var _EnvUtil = require("../util/EnvUtil");
var _Deferred = _interopRequireDefault(require("../util/Deferred"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
/* global VERSION */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
let ConfigStore = exports.default = (_class = class ConfigStore {
  constructor() {
    _initializerDefineProperty(this, "showDownload", _descriptor, this);
    _initializerDefineProperty(this, "showFullScreen", _descriptor2, this);
    _initializerDefineProperty(this, "showPrint", _descriptor3, this);
    _initializerDefineProperty(this, "exitPDFViewerType", _descriptor4, this);
    // Flag to show/hide commenting tools
    _initializerDefineProperty(this, "showCommentingToolbar", _descriptor5, this);
    // Flag to show/hide full screen modal for sizeContainer Preset
    _initializerDefineProperty(this, "showFullScreenModal", _descriptor6, this);
    this.enablePDFJavaScriptOverridePromise = new _Deferred.default();
    this._config = this.initialConfig;
    this._actionConfig = {};
  }
  get initialConfig() {
    return _ConfigStoreConstants.INITIAL_CONFIG;
  }
  get presetInitialConfig() {
    return _ConfigStoreConstants.PRESET_INITIAL_CONFIG;
  }
  get presetForceConfig() {
    return _ConfigStoreConstants.PRESET_FORCE_CONFIG;
  }
  get modernViewerConfig() {
    return _ConfigStoreConstants.MODERN_VIEWER_CONFIG;
  }
  get modernViewerInitialConfig() {
    return _ConfigStoreConstants.MODERN_VIEWER_INITIAL_CONFIG;
  }
  shouldEnableJSForTesting(version) {
    const hostName = window.location.hostname;
    if ((hostName === "stage.acrobat.adobe.com" || hostName === "dev.acrobat.adobe.com" || hostName === "local-test.acrobat.com") && version.includes("ephemeral")) {
      return true;
    }
    return false;
  }
  _initPDFJavaScript() {
    if (this._config.enableKillSwitch) {
      const killSwitchService = _ServiceRegistry.default.getService("KillSwitchService");
      killSwitchService.getOverrideValue("javaScriptEnabledVersion").then(javaScriptEnabledVersion => {
        let enablePDFJavaScript = false;
        if (javaScriptEnabledVersion && (0, _AppUtil.compareVersion)(VERSION, javaScriptEnabledVersion) >= 0 || this.shouldEnableJSForTesting(VERSION)) {
          enablePDFJavaScript = true;
        }
        this.enablePDFJavaScriptOverridePromise.resolve(enablePDFJavaScript);
      });
    } else {
      this.enablePDFJavaScriptOverridePromise.resolve(true);
    }
  }
  init(config) {
    this._config = _objectSpread(_objectSpread({}, this.initialConfig), config);
    if (this._config.externalJSComponentURL) {
      if (!(0, _EnvUtil.isValidUrl)(this._config.externalJSComponentURL)) {
        this._config.externalJSComponentURL = "";
      }
    }
    this._actionConfig = {};
    if (this._config.leftAlignFileName) {
      this._config.showBrandingTitle = false;
    }
    this._initPDFJavaScript();
  }
  setActionConfig(currentAction, actionConfig) {
    const configs = this._generateFinalConfigObjects(currentAction, actionConfig);
    this._actionConfig[currentAction] = configs.finalActionConfig;
    this._config = configs.config;
    this.setShowDownload(this._actionConfig[currentAction].showDownloadPDF);
    this.setShowPrint(this._actionConfig[currentAction].showPrintPDF);
    this.setShowFullScreen(this._actionConfig[currentAction].showFullScreen);
    this.setExitPDFViewerType(this._actionConfig[currentAction].exitPDFViewerType);
    this.setShowCommentsPanel(this._actionConfig[currentAction].annotationUIConfig.showCommentsPanel || true);
    this.setShowCommentingToolbar(this._actionConfig[currentAction].annotationUIConfig.showToolbar || true);
    this.setShowFullScreenModal(this._actionConfig[currentAction].showFullScreenModal || false);
  }
  updateActionConfig(currentAction, actionConfig = {}) {
    const currentActionConfig = this.getActionConfig(currentAction);
    Object.entries(actionConfig).forEach(([key, val]) => {
      currentActionConfig[key] = val;
    });
  }
  _getConfigWithRestriction(currentAction, actionConfig) {
    return _objectSpread(_objectSpread({}, _ConfigStoreConstants.INITIAL_ACTION_CONFIG[currentAction]), actionConfig);
  }
  _generateFinalConfigObjects(currentAction, actionConfig) {
    let finalActionConfig = this._getConfigWithRestriction(currentAction, actionConfig);
    let config = _objectSpread({}, this._config);
    if (currentAction.toLowerCase().indexOf("preview") === -1) {
      return {
        config,
        finalActionConfig
      };
    }
    let initialPresetConfig = this.presetInitialConfig[finalActionConfig.embedMode];
    if (!initialPresetConfig) {
      finalActionConfig.embedMode = _ConfigStoreConstants.defaultPreset;
      initialPresetConfig = this.presetInitialConfig[finalActionConfig.embedMode];
    }
    if (finalActionConfig.enableModernViewer) {
      const modernViewerInitialConfig = this.modernViewerInitialConfig[finalActionConfig.embedMode];
      if (modernViewerInitialConfig) {
        initialPresetConfig.actionConfig = _objectSpread(_objectSpread({}, initialPresetConfig.actionConfig), modernViewerInitialConfig.actionConfig);
        initialPresetConfig.config = _objectSpread(_objectSpread({}, initialPresetConfig.config), modernViewerInitialConfig.config);
      }
    }
    finalActionConfig = _objectSpread(_objectSpread({}, initialPresetConfig.actionConfig), finalActionConfig);
    config = _objectSpread(_objectSpread({}, initialPresetConfig.config), config);
    if (finalActionConfig.embedMode === _ViewMode.Preset.FULL_WINDOW) {
      if (finalActionConfig.defaultViewMode && !_ViewMode.default[finalActionConfig.defaultViewMode]) {
        finalActionConfig.defaultViewMode = "";
      }
    }
    if (finalActionConfig.enableModernViewer) {
      // Hiding left hand panel in case of modern viewer
      finalActionConfig.showLeftHandPanel = false;
    }
    const forcePresetConfig = this.presetForceConfig[finalActionConfig.embedMode];
    finalActionConfig = _objectSpread(_objectSpread({}, finalActionConfig), forcePresetConfig.actionConfig);
    config = _objectSpread(_objectSpread({}, config), forcePresetConfig.config);
    if (finalActionConfig.enableModernViewer) {
      const modernViewerConfig = this.modernViewerConfig[finalActionConfig.embedMode];
      if (modernViewerConfig) {
        finalActionConfig = _objectSpread(_objectSpread({}, finalActionConfig), modernViewerConfig.actionConfig);
        config = _objectSpread(_objectSpread({}, config), modernViewerConfig.config);
      }
    }
    if (finalActionConfig.embedMode === _ViewMode.Preset.IN_LINE && !finalActionConfig.showDownloadPDF) {
      finalActionConfig.showDownloadPDFInPageControl = false;
    }
    if (!finalActionConfig.showPageControls) {
      // Special requirement from preview dropin :)
      finalActionConfig.dockPageControls = true;
    }
    if (finalActionConfig.adjustSearchUIBelowTopBar) {
      finalActionConfig.adjustSearchUI = true;
    }
    if (finalActionConfig.enableLinearization && !(0, _AppUtil.isSharedArrayBufferSupported)()) {
      finalActionConfig.enableLinearization = false;
      this._linearizationForceDisabled = true;
      _ServiceRegistry.default.getService("LoggingService").info("ConfigStore", "Linearization force disabled.");
    }
    return {
      config,
      finalActionConfig
    };
  }
  get isLinearizationInitiallyEnabled() {
    const previewConfig = this.getActionConfig("preview");
    return previewConfig.enableLinearization || this._linearizationForceDisabled;
  }
  getActionConfig(currentAction) {
    return this._actionConfig[currentAction] || {};
  }
  getConfig() {
    return this._config;
  }
  getPollingConfig() {
    const saveConfig = _ServiceRegistry.default.getService("CallbackService").getCallbackOptions(_CallbackTypes.default.SAVE_API) || {};
    return _objectSpread(_objectSpread(_objectSpread({}, this.getStatusCallbackConfig()), "autoSaveFrequency" in saveConfig ? {
      autoSaveFrequency: saveConfig.autoSaveFrequency
    } : {}), "enableFocusPolling" in saveConfig ? {
      enableFocusPolling: saveConfig.enableFocusPolling
    } : {});
  }

  // eslint-disable-next-line class-methods-use-this
  getStatusCallbackConfig() {
    const statusConfig = _ServiceRegistry.default.getService("CallbackService").getCallbackOptions(_CallbackTypes.default.STATUS_API);
    return _objectSpread(_objectSpread({}, _ConfigStoreConstants.DEFAULT_STATUS_CALLBACK_CONFIG), statusConfig || _ConfigStoreConstants.MISSING_STATUS_CALLBACK_CONFIG);
  }

  // eslint-disable-next-line class-methods-use-this
  getSaveCallbackConfig() {
    const saveConfig = _ServiceRegistry.default.getService("CallbackService").getCallbackOptions(_CallbackTypes.default.SAVE_API);
    let defaultSaveConfig = _ConfigStoreConstants.DEFAULT_SAVE_CALLBACK_CONFIG;
    let missingSaveCallbackConfig = _ConfigStoreConstants.MISSING_SAVE_CALLBACK_CONFIG;
    const previewConfig = this.getActionConfig("preview");
    if (previewConfig.enableModernViewer) {
      defaultSaveConfig = _ConfigStoreConstants.DEFAULT_MODERN_VIEWER_SAVE_CALLBACK_CONFIG;
      missingSaveCallbackConfig = _ConfigStoreConstants.MISSING_MODERN_VIEWER_SAVE_CALLBACK_CONFIG;
    }
    // TODO:: until incremental support is added in Preview dropin, removing its support.
    const saveCallbackConfig = _objectSpread(_objectSpread(_objectSpread({}, defaultSaveConfig), saveConfig || missingSaveCallbackConfig), {}, {
      incremental: false
    });
    if (this._config.isViewSDKPublic) {
      saveCallbackConfig.showError = true;
    }
    return saveCallbackConfig;
  }
  getIntegrationName() {
    return this._config.integrationName;
  }
  hasAdobeMenuActions() {
    const {
      showLegalNotice,
      helpUrl
    } = this._config;
    return showLegalNotice || helpUrl;
  }
  _sendActionConfigUpdate() {
    if (!this._config.isViewSDKPublic) {
      _ServiceRegistry.default.getService("AppStore").sendActionConfigUpdate();
    }
  }
  setShowDownload(value) {
    this.showDownload = value;
    this._sendActionConfigUpdate();
  }
  setShowFullScreen(value) {
    this.showFullScreen = value;
    this._sendActionConfigUpdate();
  }
  setExitPDFViewerType(value) {
    this.exitPDFViewerType = value;
  }
  setShowFullScreenModal(value) {
    this.showFullScreenModal = value;
  }
  setShowCommentsPanel(value) {
    this.showCommentsPanel = value;
  }
  setShowPrint(value) {
    this.showPrint = value;
    if (!value) {
      (0, _KeyboardEventUtils.blockPrint)();
      this.printBlocked = true;
    } else if (this.printBlocked) {
      (0, _KeyboardEventUtils.unblockPrint)();
      this.printBlocked = false;
    }
    this._sendActionConfigUpdate();
  }
  setShowCommentingToolbar(value) {
    this.showCommentingToolbar = value;
    this._sendActionConfigUpdate();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "showDownload", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showFullScreen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showPrint", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "exitPDFViewerType", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return _ViewMode.LightBoxExitPDFViewerType.CLOSE;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showCommentingToolbar", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showFullScreenModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setShowDownload", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowDownload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowFullScreen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowFullScreen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setExitPDFViewerType", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setExitPDFViewerType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowFullScreenModal", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowFullScreenModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowCommentsPanel", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowCommentsPanel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowPrint", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowPrint"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowCommentingToolbar", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowCommentingToolbar"), _class.prototype)), _class);